import "./imports";
import VueWait from "vue-wait";

export default {
  name: "App",
  wait: new VueWait({})
};
